import { Typography } from 'mobily-ui-library/lib';
import SucessIcon from '../../assets/CircleSuccess.svg';
import './Success.scss';

type Props = {
  rtl: boolean;
}

function Success({ rtl }: Props) {
  return (
    <section className='success__container'>
      <div className='row'>
        <main>
          <img className='success--icon' src={SucessIcon} alt='success' />
          <Typography rtl={rtl} className='success--title thankYou'>Thank You</Typography>
          <Typography rtl={rtl} className='recordSuccess'>You are successfully logged in!</Typography>
        </main>
        <Typography className='note-description'>
          <span>Note:</span> Please return back to main application.
        </Typography>
      </div>
    </section>
  )
}

export default Success